import { Stack } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import Header from '@/components/Layout/Header';

export default function PatientFormLayout() {
  return (
    <>
      <StatusBar style="light" backgroundColor="#678aae" />
      <Stack
        screenOptions={{
          header: () => <Header withProfile={false} />,
          animation: 'slide_from_right',
          headerBackTitleVisible: false,
          gestureEnabled: true,
        }}
      >
        <Stack.Screen name="[token]" />
        <Stack.Screen name="form" />
        <Stack.Screen name="biometrie" />
        <Stack.Screen name="habitudes" />
        <Stack.Screen name="confirmation" />
        <Stack.Screen
          name="success"
          options={{
            headerShown: false,
            gestureEnabled: false,
          }}
        />
        <Stack.Screen name="error-access" />
      </Stack>
    </>
  );
}